// extracted by mini-css-extract-plugin
export const root = "fc-press-releases-module--root--tx4UF";